module.exports = __webpack_public_path__ + "static/media/a-japanese-dinner.28513982.jpg";